import { Theme } from '@material-ui/core';

export const MuiSnackbarContent = (theme: Theme): {} => ({
  root: {
    boxShadow: `${theme.shadows[9]}, ${theme.shadows[5]}`,
  },
});
